import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import { displayDate } from '@iso/lib/helpers/utility';

const myDisplayDate = (t) => {
    return (typeof t === 'undefined' || t.length === 0) ? <Text>/      /</Text> : 
        <Text style={{textIndent:'5px', letterSpacing: 1,}}>{((typeof t !== 'undefined') ? displayDate(t) : '')}</Text>;
};

const styles = StyleSheet.create({
    titleContainer:{
        flexDirection: 'row'
    },
    reportText:{
        color: '#000',
        letterSpacing: 1,
        fontSize: 11
    },
    reportTextUnderscore:{
        color: '#000',
        letterSpacing: 1,
        fontSize: 9,
        height: '14px',
        textIndent: '2px',
        marginTop: '-1px',
        borderBottom: '1px #000 solid',
        paddingBottom:'-2px'
    },
  });

  const OrderServiceFooter = ({data}) => (
    <>
    <View style={{...styles.titleContainer, 'marginTop': 24}}>
        <Text style={{...styles.reportText, width:'90px'}}>Realizado por:</Text>
        <Text style={{...styles.reportTextUnderscore, width:'200px'}}></Text>
        <Text style={{...styles.reportText, width:'115px', marginLeft:'30px'}}>Data de conclusão:</Text>
        <Text style={{...styles.reportTextUnderscore, width:'100px', textAlign:'right'}}> </Text>
    </View>
    <View style={{...styles.titleContainer, 'marginTop': 5}}>
        <Text style={{...styles.reportText, width:'90px'}}>Conferido por:</Text>
        <Text style={{...styles.reportTextUnderscore, width:'200px'}}>{data?.orderService?.reviewedBy?.name}</Text>
        <Text style={{...styles.reportText, width:'120px', marginLeft:'30px'}}>Data da conferência:</Text>
        <Text style={{...styles.reportTextUnderscore, width:'100px', textAlign:'center'}}>{myDisplayDate(data?.orderService?.reviewedBy?.date)}</Text>
    </View>
    </>
  );
  
  export default OrderServiceFooter